






import Vue from "vue";

export default Vue.extend({
  props: {
    value: {
      type: String,
      required: true,
      default: "pending"
    }
  },
  data() {
    return { currentStatus: this.value };
  },
  computed: {
    statuses() {
      return ["pending", "in_progress", "passed", "failed"];
    }
  },
  watch: {
    currentStatus(newStatus: String) {
      this.$emit("input", newStatus);
    }
  }
});
